import { CLIENT_PORTAL_MONITORING_ACCESS_ROLE_CODES } from "@certn/client-users";

import { useUser } from "../../hooks/useUser";

/** Admin, Manager, and Proxy roles only (frontend gate; LD flag applied separately). */
export function useCanViewMonitoring(): boolean {
  const { details } = useUser();
  const roles = details?.roles || [];

  return roles.some((role) =>
    CLIENT_PORTAL_MONITORING_ACCESS_ROLE_CODES.includes(
      role.code as (typeof CLIENT_PORTAL_MONITORING_ACCESS_ROLE_CODES)[number]
    )
  );
}
